import { Button, Drawer, Form, Input, message, Select } from 'antd';
import {
  CREATE_ERROR,
  EDIT_ERROR,
  REQUEST_LOADING,
  SUCCESS_CREATE,
  SUCCESS_UPDATE,
} from 'constants/alerts';
import { CONTENT_SPAN, LABEL_SPAN } from 'constants/table';
import { useEffect, useMemo } from 'react';
import { EdoAlertService } from 'services/EdoService';
import { requiredRule } from 'utils/forms/validationRules';

export const type = [
  { text: 'Успешно', value: 'success' },
  { text: 'Уведомление', value: 'info' },
  { text: 'Предупреждение', value: 'warning' },
  { text: 'Ошибка', value: 'error' },
];

export const typeOfEdo = [
  { text: 'Такси', value: 'taxi' },
  { text: 'Парк', value: 'park' },
  { text: 'Smartfleet', value: 'smartfleet' },
  { text: 'Fleetsoft', value: 'fleetsoft' },
  { text: 'Transline', value: 'transline' },
  { text: 'Яндекс партнеры', value: 'ya' },
];

export const is_active = [
  { text: 'Да', value: true },
  { text: 'Нет', value: false },
];

function EdoAlertForm({ isActive, initialValues, onClose, onSuccess }) {
  const [form] = Form.useForm();

  const isEdit = useMemo(() => {
    return Boolean(initialValues && initialValues.id);
  }, [initialValues]);

  useEffect(() => {
    if (initialValues) {
      form.setFieldsValue(initialValues);
    } else {
      form.resetFields();
    }
  }, [initialValues]);

  const handleSubmit = (values) => {
    handleUpdateOrCreate(values, initialValues?.id);
  };

  const handleUpdateOrCreate = async (data, id) => {
    const hide = message.loading(REQUEST_LOADING);
    if (!data?.page_type) {
      data.page_type = [];
    }

    try {
      if (isEdit) {
        const isUpdatedOrCreated = await EdoAlertService.editEdoAlert(data, id);
        if (isUpdatedOrCreated) {
          onClose();
          onSuccess();
          form.resetFields();
          message.success(isEdit ? SUCCESS_UPDATE : SUCCESS_CREATE);
        }
      } else {
        const isUpdatedOrCreated = await EdoAlertService.createEdoAlert(data);
        if (isUpdatedOrCreated) {
          onClose();
          onSuccess();
          form.resetFields();
          message.success(isEdit ? SUCCESS_UPDATE : SUCCESS_CREATE);
        }
      }
    } catch (err) {
      message.error(isEdit ? EDIT_ERROR : CREATE_ERROR);
    } finally {
      hide();
    }
  };

  return (
    <Drawer
      title={
        isEdit ? 'Редактирование уведомления ЭДО' : 'Создание уведомления ЭДО'
      }
      width="50%"
      onClose={onClose}
      visible={isActive}
      getContainer={false}
    >
      <Form
        form={form}
        onFinish={handleSubmit}
        layout="horizontal"
        labelCol={{
          span: LABEL_SPAN,
        }}
        wrapperCol={{ span: CONTENT_SPAN }}
        labelAlign="right"
        initialValues={{
          alert_type: 'warning',
          allow_sign: true,
          is_for_all: false,
        }}
      >
        <Form.Item name="title" label="Заголовок" rules={[requiredRule]}>
          <Input placeholder="Заголовок" />
        </Form.Item>
        <Form.Item name="description" label="Описание" rules={[requiredRule]}>
          <Input placeholder="Описание" />
        </Form.Item>
        <Form.Item
          name="title_kz"
          label="Заголовок (Каз)"
          rules={[requiredRule]}
        >
          <Input placeholder="Заголовок (Каз)" />
        </Form.Item>
        <Form.Item
          name="description_kz"
          label="Описание (Каз)"
          rules={[requiredRule]}
        >
          <Input placeholder="Описание (Каз)" />
        </Form.Item>
        <Form.Item name="alert_type" label="Тип" rules={[requiredRule]}>
          <Select placeholder="Тип">
            {type.map(({ value, text }) => (
              <Select.Option key={value} value={value}>
                {text}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          name="allow_sign"
          label="Разрешить подпись"
          rules={[requiredRule]}
        >
          <Select placeholder="Разрешить подпись">
            {is_active.map(({ value, text }) => (
              <Select.Option key={value} value={value}>
                {text}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item name="page_type" label="Сайт">
          <Select mode="multiple" placeholder="Сайт">
            {typeOfEdo.map(({ value, text }) => (
              <Select.Option key={value} value={value}>
                {text}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item
          name="is_for_all"
          label="Для всех сайтов"
          rules={[requiredRule]}
        >
          <Select placeholder="Для всех сайтов">
            {is_active.map(({ value, text }) => (
              <Select.Option key={value} value={value}>
                {text}
              </Select.Option>
            ))}
          </Select>
        </Form.Item>

        <Form.Item wrapperCol={{ offset: CONTENT_SPAN }}>
          <Button type="primary" htmlType="submit">
            {isEdit ? 'Редактировать' : 'Создать'}
          </Button>
        </Form.Item>
      </Form>
    </Drawer>
  );
}

export { EdoAlertForm };
